import {Inject, Injectable, Injector, NgZone, Renderer2, RendererFactory2} from '@angular/core';
import {DialogService, DynamicDialogConfig} from "primeng/dynamicdialog";
import {Observable, of, Subscription, timer} from "rxjs";
import {mergeMap, tap} from "rxjs/operators";
import {SessionAlertComponent} from "../../components/session-alert/session-alert.component";
import {ModulTozsamosciService} from "../modul-tozsamosci-service/modul-tozsamosci.service";
import {MtHelper} from "../../utils/mt-helper";
import {REFRESH_TOKEN_TIME_SHIFT, USER_ACTIVITY_TIME_SHIFT} from "../../utils/tokens";

@Injectable({
  providedIn: 'root'
})
export class SessionAlertService {

  private renderer: Renderer2;
  private subscription: Subscription;
  private userLastActivityTime: Date = null;
  private dialogService: DialogService;

  constructor(rendererFactory: RendererFactory2,
              private injector: Injector,
              private ngZone: NgZone,
              private mtService: ModulTozsamosciService,
              @Inject(REFRESH_TOKEN_TIME_SHIFT) private REFRESH_TOKEN_TIME_SHIFT: number,
              @Inject(USER_ACTIVITY_TIME_SHIFT) private USER_ACTIVITY_TIME_SHIFT: number
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.ngZone.runOutsideAngular(this.startTrackUserActivityMouseEvent.bind(this));
    this.ngZone.runOutsideAngular(this.startTrackUserActivityKeyboardEvent.bind(this));
  }

  updateAlertTimer(refreshTokenExpiresIn: number): void {
    if (refreshTokenExpiresIn < 0) {
      return;
    }
    this.subscription?.unsubscribe();
    this.subscription = timer(refreshTokenExpiresIn)
      .pipe(
        mergeMap(() => this.isUserActive() ? of(true) : this.openDialog()),
        tap((value) => this.handleDialogResult(value))
      ).subscribe()
  }

  private openDialog(): Observable<boolean> {
    this.dialogService = this.injector.get(DialogService);
    const dialogConfig: DynamicDialogConfig = { width: '50%', showHeader: false };
    return this.dialogService.open(SessionAlertComponent, dialogConfig).onClose;
  }

  private handleDialogResult(value: boolean): void {
    !value
      ? this.mtService.logOut()
      : this.mtService.getNewAccessToken()
          .pipe(
            tap(() => this.updateAlertTimer(MtHelper.getAlertTime(this.mtService.getRefreshTokenExpiration(), this.REFRESH_TOKEN_TIME_SHIFT)))
          ).subscribe()
  }

  private startTrackUserActivityMouseEvent(): void {
    this.renderer.listen('window', 'mousemove', () => this.onEvent());
  }

  private startTrackUserActivityKeyboardEvent(): void {
    this.renderer.listen('window', 'keydown', () => this.onEvent());
  }

  private onEvent(): void {
    this.userLastActivityTime = new Date();
  }

  private isUserActive(): boolean {
    return !this.userLastActivityTime
      ? false
      : MtHelper.isUserActive(this.userLastActivityTime.getTime(), this.USER_ACTIVITY_TIME_SHIFT);
  }

}
